// Copyright (c) Docugami, Inc. All rights reserved.

import { chunkSelectedBorderColor, primaryTheme } from "components/shell/presentation/AppStyles";
import { BoundsComponent } from "sdv/components/BoundsComponent";
import { OverlayComponent } from "sdv/components/OverlayComponent";
import { ComponentId } from "sdv/engine/Component";
import { ISystem, Queries } from "../engine/Engine";
import { growBox } from "store/shared_types";

/**
 * Handles outflow specific selection logic
 */
export class OutflowSelectionSystem implements ISystem {
    get updateEnabled() { return true; }

    queries: Queries = {
        roots: { types: [ComponentId.RootControl, ComponentId.Bounds] }
    }

    update() {
        this.updateOverlays();
    }

    private updateOverlays() {
        for (const entity of this.queries.roots.query!.entities) {
            if (entity.hasComponent(ComponentId.Default)) {
                continue;
            }

            if (entity.hasComponent(ComponentId.Active)) {
                if (!entity.hasComponent(ComponentId.Overlay)) {
                    const bounds = entity.getComponent<BoundsComponent>(ComponentId.Bounds)!;
                    if (!!bounds.bounds.length) {
                        entity.addComponent<OverlayComponent>({
                            typeId: ComponentId.Overlay,
                            color: primaryTheme.palette.white,
                            boxesToExclude: [{
                                box: growBox(entity.getComponent<BoundsComponent>(ComponentId.Bounds)!.boundingBox, 10, 10, 10, 10),
                                strokeColor: chunkSelectedBorderColor,
                                strokeWidth: 2
                            }],
                            opacity: 0.8
                        });
                    }
                }
            }
            else {
                entity.removeComponent(ComponentId.Overlay);
            }
        }
    }
}
